import React, { memo } from 'react';
import clsx from 'clsx';
import { Icon } from '../icon';
import { ArrowIcon } from '../icons';
import styles from './styles.module.css';
export const Separator = /*#__PURE__*/memo(function Separator({
  children = /*#__PURE__*/React.createElement(ArrowIcon, {
    direction: "right"
  }),
  className,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(Icon, {
    className: clsx(styles.separator, className),
    "data-testid": "breadcrumbSeparator",
    ...rest
  }, children);
});